import TreeNodeModel from 'models/TreeNode';
import { observable, computed } from 'mobx';
import { deserialize, serialize } from 'serializers/EtsngNode';

export default class EtsngNode extends TreeNodeModel {

  @observable id
  @observable parentId
  @observable code
  @observable description
  @observable fromDate
  @observable toDate
  @observable iscode
  @observable level
  @observable etsngClass
  @observable gngCode
  @observable minWeight

  @computed get store() {
    return this.rootStore.etsngTreeStore;
  }

  parse(json) {
    return deserialize(json);
  }

  toJSON() {
    return serialize(this);
  }

}



// WEBPACK FOOTER //
// ./src/models/EtsngNode.js